<template>
  <div>
      <div v-if="!pageNotConfirm">

      <a-page-header title="Instance App Settings">
        <template slot="extra">
          <a-button key="1" type="primary" @click="showAddModal()"
            >Add New Instance App Settings</a-button
          >
        </template>
      </a-page-header>
      
      <data-table
        id="table-wrapper"
        ref="instanceAppSettingDataTable"
        :columns="columns"
        :data-source="instanceAppSettingsState.instanceAppSettings"
        :loading="loading"
        @refreshData="fetchInstanceAppSettings"
        :totalCount="instanceAppSettingsState.instanceAppSettingsCount"
        rowKey="id"
      >
        <span slot="appSettingValue" slot-scope="record">
          {{ !record.isSensetive ? record.appSettingValue : "**********" }}
          <a-icon style="float:right" :type="record.isSensetive ? 'lock' : 'unlock'" />
        </span>

        <span slot="action" slot-scope="record">
          <a-tooltip title="Edit">
            <a class="edit-icon" @click="showEditModal(record.id)">
              <a-icon type="edit" />
            </a>
          </a-tooltip>
          <a-divider type="vertical" />
          <a-tooltip title="Delete">
            <a class="trash-icon" @click="confirmDelete(record.id)">
              <a-icon type="delete" /> </a
          ></a-tooltip>
        </span>
      </data-table>
      </div>
      <InstanceAppSettingsModal
        v-model="isInstanceAppSettingsModalVisible"
        :businesses="businessState.businesses"
        :instanceAppSetting="instanceAppSettings"
        :title="modalTitle"
        :mode="mode"
      ></InstanceAppSettingsModal>
      <TempPassConfirm v-model="pageNotConfirm"   @confirm="checkTempPass"></TempPassConfirm>
    
  </div>
</template>
<script>
import {
  instanceAppSettingsState,
  instanceAppSettingsMutations,
  businessState,
  businessMutations,
} from "../../Store/store.js";
import InstanceAppSettingsModal from "./InstanceAppSettingsModal.vue";
import TempPassConfirm from "../Share/TempPassConfirm.vue"

const columns = [
  {
    title: "Key",
    dataIndex: "appSettingKey",
    key: "appSettingKey",
    sorter: true,
    ellipsis: true,
    width: '10%',
  },
  {
    title: "Value",
    key: "limit",
    scopedSlots: { customRender: "appSettingValue" },
    sorter: true,
    ellipsis: true,
    textWrap: 'word-break'
  },
  {
    title: "Actions",
    key: "action",
    scopedSlots: { customRender: "action" },
    ellipsis: true,
    width: 70,
  },
];

export default {
  async mounted() {
    await this.fetchInstanceAppSettings();
    await this.fetchBusinesses();
  },
  data() {
    return {
      instanceAppSettingsState,
      instanceAppSettingsMutations,
      businessState,
      businessMutations,
      columns: columns,
      isSaving: false,
      loading: false,
      isInstanceAppSettingsModalVisible: false,
      instanceAppSettings: {},
      mode: "Add",
      modalTitle: "",
      pageNotConfirm:true
    };
  },
  methods: {
    async fetchInstanceAppSettings(params) {
      await this.instanceAppSettingsMutations.setInstanceAppSetting(params);
    },
    async fetchBusinesses() {
      await businessMutations.setBusinesses();
    },
    showAddModal() {
      this.mode = "Add";
      this.instanceAppSettings = {};
      this.modalTitle = `${this.mode} Instance App Settings`;
      this.isInstanceAppSettingsModalVisible = true;
    },
    showEditModal(recordId) {
      this.mode = "Update";
      this.instanceAppSettings = {
        ...this.instanceAppSettingsState.instanceAppSettings.find(
          (i) => i.id == recordId
        ),
      };
      this.modalTitle = `${this.mode} instance App Settings`;
      this.isInstanceAppSettingsModalVisible = true;
    },
    checkTempPass(value){
      this.pageNotConfirm=value;
    },
    confirmDelete(instanceAppSettingsId) {
      let self = this;
      this.$confirm({
        title: "Delete Instance App Settings",
        content: "Are you sure you want to delete this instance App Settings?",
        okText: "Delete",
        okType: "danger",
        cancelText: "Cancel",
        onOk() {
          self.deleteInstanceAppSettings(instanceAppSettingsId);
        },
        onCancel() {},
      });
    },
    async deleteInstanceAppSettings(instanceAppSettingsId) {
      try {
        let deleteResponse =
          await this.instanceAppSettingsMutations.deleteInstanceAppSetting(
            instanceAppSettingsId
          );
        if (deleteResponse?.status == 200) {
          this.$message.success("Instance App Settings deleted successfully!");
        }
      } catch (error) {
        this.showError(error);
      } finally {
        this.$refs.instanceAppSettingDataTable.refreshData(true);
      }
    },
  },
  components: {
    InstanceAppSettingsModal,
    TempPassConfirm
  },
};
</script>